import { useState } from 'react';
import { DialogContent } from '@mui/material';
import DocumentControlDataGrid from '@components/DataGrid/DocumentControl/Grid';
import ApplicationModal from '@components/Modals/ApplicationModal';

import styles from './DocumentControl.module.css';

/**
 * Local function used for rendering the Document Control modal
 */

export default function DocumentControlModal() {
	const [isOpen, setIsOpen] = useState(true);

	return (
		<ApplicationModal
			isOpen={isOpen}
			onClose={() => {
				setIsOpen(false);
			}}
			title='Document Control'
		>
			<DialogContent className={styles['document-control-content']}>
				<DocumentControlDataGrid />
			</DialogContent>
		</ApplicationModal>
	);
}
